import type {ValueEditorLabelContext} from './value-editor-label-context';

export function ariaLabelledby(node: HTMLElement, labelContext: ValueEditorLabelContext) {
    if (!!labelContext) {
        node.setAttribute('aria-labelledby', labelContext.labelId);
        labelContext.config.update((currentConfig) => ({...currentConfig, disableForAttribute: true}));
    }
}